/* Format status */
export default (value) => {
    let days = {
        '1' : 'En Espera',
        '2' : 'En Consulta',
        '3' : 'Ausente',
        '4' : 'Cancelada',
        '5' : 'Reprogramada',
        '6' : 'Completado'
    }
    return days[String(value)];
}


// WEBPACK FOOTER //
// ./src/filters/formatStatus.js